import { IdNamePair, ISimpleUser } from "modules/common/models";
import { IModification } from "modules/emails/models"; 

export interface ISMSListing {
    currentPage: number;
    sms: ISMSListItem[];
    totalPages: number;
    totalSMS: number;
}

export interface ISMSAudienceTotals {
    audienceTotalUsers: number;
    audienceOptedUsers: number;
}

interface IBaseSMSDetails {
    title: string;
    fromSender: ISimpleUser;
    fromNumber?: string;
}

interface ISMSBodyContent {
    plainBody: string; 
    htmlBody: string;
}

interface ISMSIdsIncluded {
    id: string;
    tenantId: string;
}

export interface ISMS extends IBaseSMSDetails, ISMSBodyContent, ISMSIdsIncluded {
    status: SMSStatus;
    audiences: IdNamePair<string, string>[];
    sentBy?: IdNamePair<string, string>;
    sentTime?: string;
    sendToAllUsers: boolean;
}

export interface ISMSInput extends IBaseSMSDetails, ISMSBodyContent {
    audiences: string[];
    sendToAllUsers: boolean;
    sentTime?: string;
}

export interface ISMSListItem extends IBaseSMSDetails, ISMSIdsIncluded {
    createdBy: IdNamePair<string, string>;
    createdTime: Date;
    sentTime?: Date;
    lastModification: IModification;
    sentBy?: IdNamePair<string, string>;
    status: SMSStatus;
}

export interface ISMSSentConfirmation {
    shouldShowDialog: boolean,
    expectedSentTime: string,
    smsId: string,
}


export interface ISMSListing {
    currentPage: number;
    sms: ISMSListItem[];
    totalPages: number;
    totalSMS: number;
}

export interface ISMSEditorState {
    sms: ISMS;
    originalSms: ISMS;
    changedSinceLastSaved: boolean;
    isFetching: boolean;
    isSaving: boolean;
    testNumbers: string[];
    shouldDownloadRecipientsList: boolean;
    shouldSendTestSMS: boolean;
    shouldOpenOneLastCheck: boolean;
}

export interface ISMSState {
    draftSMSList: ISMSListingPage;
    scheduledSMSList: ISMSListingPage;
    sentSMSList: ISMSListingPage;
    editor: ISMSEditorState;
    successMessage: string,
    errorMessage: string,
    sentConfirmation: ISMSSentConfirmation;
    redirectUrl?: string;
}

export interface ISMSListingPage extends ISMSListing {
    id: SMSStatus;
    isFetching: boolean;
}

export enum SMSStatus {
    Draft = "draft",
    Scheduled = "scheduled",
    Sent = "sent"
}


export enum SMSSortStyle {
    TitleAsc = "titleAsc",
    TitleDesc = "titleDesc",
    ModifiedByAsc = "modifiedByAsc",
    ModifiedByDesc = "modifiedByDesc",
    ModifiedAtAsc = "modifiedAtAsc",
    ModifiedAtDesc = "modifiedAtDesc",
    FromNumberAsc = "fromNumberAsc",
    FromNumberDesc = "fromNumberDesc",
    SentByAsc = "sentByAsc",
    SentByDesc = "sentByDesc",
    SentTimeAsc = "sentTimeAsc",
    SentTimeDesc = "sentTimeDesc"
}

export interface ISMSFilters {
    textToSearch: string;
    status: SMSStatus;
    createdByMeOnly: boolean;
    sortBy: SMSSortStyle;
}

//Used for OneLastCheck so we can pass individual parameters.
export interface ISMSPreviewDetails {
    audiences: IdNamePair<string, string>[];
    sendToAllUsers: boolean;
    title?: string;
    sentTime?: string;
    fromNumber: string;
    textBody: string;
}

const DEFAULT_SMS_FILTERS = {
    textToSearch: "",
    createdByMeOnly: false,
    sortBy: SMSSortStyle.ModifiedAtDesc
}

export const DEFAULT_DRAFT_SMS_FILTERS: ISMSFilters = {
    ...DEFAULT_SMS_FILTERS,
    status: SMSStatus.Draft,
}

export const DEFAULT_SCHEDULED_SMS_FILTERS: ISMSFilters = {
    ...DEFAULT_SMS_FILTERS,
    sortBy: SMSSortStyle.SentTimeDesc,
    status: SMSStatus.Scheduled,
}

export const DEFAULT_SENT_SMS_FILTERS: ISMSFilters = {
    ...DEFAULT_SMS_FILTERS,
    sortBy: SMSSortStyle.SentTimeDesc,
    status: SMSStatus.Sent,
}